export default "/kiban/_next/static/images/gic_ukas_2017-5102a9c321eb8fed1de64523acb4bbc1.png";